import {Grid, Typography} from "@material-ui/core"
import React from "react"
import './entry.css'
const Entry = ({image,title,subtitle,content}) => {
    // console.log(typeof content)
    return (
      <div className="entry">
        <Grid item md={1} xs={2} >
            <img alt={image.alt} src={image.src} className="entry_img"/>
        </Grid>
        <Grid item md={10} xs={9} >
            <div className="line-pattern padding1">
                <Typography variant='h5'>
                    {title}
                </Typography> 
                <Typography variant='h6' className="grey">
                    {subtitle}
                </Typography> 
                <Typography variant='h5'>
                    {content}
                </Typography> 
            </div>
        </Grid>
      </div>
    )
  }


const PaperEntry = ({image,title,subtitle,content}) => {

// console.log(typeof content)
return (
    <div className="entry">
        <Grid item md={4} xs={12} >
            <img alt={image.alt} src={image.src} className="entry_img"/>
        </Grid>
        <Grid item md={8} xs={12} >
            <div className="line-pattern padding1">
                <Typography variant='h5'>
                    {title}
                </Typography> 
                <Typography variant='h5'>
                    {subtitle}
                </Typography> 
                <Typography variant='h5'>
                    {content}
                </Typography> 
            </div>
        </Grid>
    </div>
)
}

export {Entry,PaperEntry}